/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Inject, Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {ogTranslate} from './og-translate';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Injectable({providedIn: 'root'})
export class OgTranslateService {
  constructor(
    private readonly translate: TranslateService,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any
  ) {
  }

  transform(code: string, defaultText?: string, interpolateParams?: object): string {
    return ogTranslate(
      code,
      defaultText,
      (key) => this.LocalNetworkProfile.getNetworkTranslations(key),
      (key, params) => this.translate.instant(key, params),
      interpolateParams
    );
  }
}
